var DeviceType;
(function (DeviceType) {
  DeviceType["TABLET"] = "tablet";
  DeviceType["MOBILE"] = "mobile";
  DeviceType["DESKTOP"] = "desktop";
})(DeviceType || (DeviceType = {}));

export { DeviceType as D };
